import { Component, OnInit,ViewEncapsulation,HostListener } from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { NgForm } from '@angular/forms';
import { HelperService } from '../helper.service';
import { Http, Response,Headers } from '@angular/http';
import {MatSnackBar} from '@angular/material';
import {CookieService} from 'angular2-cookie/core';
// import {Location, Appearance, GermanAddress} from '@angular-material-extensions/google-maps-autocomplete';

// import PlaceResult = google.maps.places.PlaceResult;

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css'],
  providers: [HelperService] 
})
export class AddressComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }

  // public appearance = Appearance;
  // public zoom: number;
  // public latitude: number;
  // public longitude: number;
  // public selectedAddress: PlaceResult;
  studentid
  packageid;
  user=this.cookie.get('user_id');
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private http:Http, private helper:HelperService,private snackbar: MatSnackBar,private titleService: Title,private activatedRoute: ActivatedRoute,private router: Router,private cookie:CookieService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.studentid = params['studentid'];
      this.packageid = params['packageid'];
      // alert(this.studentid);
      // alert(this.packageid);
    });
    // this.titleService.setTitle('Home | @angular-material-extensions/google-maps-autocomplete');
 
    // this.zoom = 10;
    // this.latitude = 52.520008;
    // this.longitude = 13.404954;
 
    // this.setCurrentPosition();
 
  }
  add_form(addForm: NgForm){
    let body = new FormData();
    //alert(this.start_dates);
    // console.log(addForm.value.address);
    // console.log(addForm.value.city);

    // console.log(addForm.value.state);
    // console.log(addForm.value.country);
    // console.log(this.studentid);
    // console.log(this.packageid);
    //return;
    body.append('studentid',this.studentid);
    //body.append('password', addForm.value.password);
    //body.append('deviceid', addForm.value.deviceid);
    body.append('packageid',this.packageid);
    body.append('address',addForm.value.address);
    body.append('city',addForm.value.city);
    body.append('state',addForm.value.state);
    body.append('country',addForm.value.country);
    body.append('pincode',addForm.value.pincode);
    //body.append('user_id',this.user);

     this.http.post(this.helper.base_url+'http/add/codsubscription', body,{ headers: this.headers })
     .subscribe(
       (res) => {
       let  data=JSON.parse(res['_body']);
      if(!data.error){
        alert("success");
        this.router.navigate(["/appusers"]);
         //this.listClick(null) ;
        //this.refresh(false,'Parent added successfully') ;
      }else{
        //  this.listClick(null) ;
        // this.error_refresh(false,data.message) ;
        this.snackbar.open(data.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
      }
      
    //    }, //For Success Response
    //     err => {console.error(err)} //For Error Response);
    //  );
   });
 
//   private setCurrentPosition() {
//     if ('geolocation' in navigator) {
//       navigator.geolocation.getCurrentPosition((position) => {
//         this.latitude = position.coords.latitude;
//         this.longitude = position.coords.longitude;
//         this.zoom = 12;
//       });
//     }
//   }
 
//   onAutocompleteSelected(result: PlaceResult) {
//     console.log('onAutocompleteSelected: ', result);
//   }
 
//   onLocationSelected(location: Location) {
//     console.log('onLocationSelected: ', location);
//     this.latitude = location.latitude;
//     this.longitude = location.longitude;
//   }
 
//  onGermanAddressMapped($event: GermanAddress) {
//     console.log('onGermanAddressMapped', $event);
//   }
  }
}



// WEBPACK FOOTER //
// ./src/app/address/address.component.ts